<template>
    <div class="footer__info-countries">
        <p class="footer__info-countries-title">Internacional</p>
        <ul class="footer__info-countries-list">
            <li class="footer__info-countries-list--item" v-for="country in enableCountries" :key="country.alias">
                <a class="country" :class="[ country.alias.toLowerCase() === current_country ? 'active' : '' ]" :href="`/${country.ruta_publica}`">
                    <img class="country-logo" :src="`/img/banderas/png/${country.ruta_publica}.png`" :alt="`${country.nombre.toLowerCase()}`">
                    <span class="country-name">{{ country.nombre }}</span>
                    <span class="country-current">Estás aquí</span>
                </a>
            </li>
            <li class="footer__info-countries-list--item">
                <p class="another-country">
                    <span class="icon-info"></span>
                    <span>¿No ves tu país?</span>
                </p>
                <div class="tooltipCountry">
                    <span>Actualmente trabajamos para fortalecer nuestra expansión internacional</span>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
/** eslint-disable */
export default {
    name: 'ContriesFooterList',
    props: {
        current_country: {
            require: true,
        },
        paises_disabled_manual: {
            require: true,
            type: String,
            default: ''
        }
    },
    computed: {
        /**
         * Paises habilitados
         * 
         * @author Óscar
         */
        enableCountries: function () {
            return window.app.__vue__.paises.filter(country => ! this.disableCountries.includes(country.alias.toLowerCase()));
        },
        
        /**
         * Aliases de los países deshabilitados
         * 
         * @author Óscar
         */
        disableCountries: function () {
            return this.paises_disabled_manual.split(',');
        },
    }
}
</script>
